import { colord } from "colord";
import { Constants } from "../constants/Constants";

export class Functions {
  public static decode(str: string): string {
    try {
      return decodeURIComponent(escape(str))
    } catch (error) {
      return str;
    }
  }

  public static ColorIsLight(color: string): boolean {
    if (!color) return false;
    return colord(color).brightness() >= Constants.Colors.IS_LIGHT_BRIGHTNESS_THRESHOLD;
  }
}
